import { Component, Input, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-input-field',
  templateUrl: './input-field.component.html',
  styleUrls: ['./input-field.component.css']
})
export class InputFieldComponent {
  @Input() type: string;
  @Input() id: string;
  @Input() controlName: string;
  @Input() key: string;
  @Input() form: FormGroup;
  @Input() class = 'field';
  @Input() min = 0;
  @Input() minlength: number;
  @Input() maxlength: number;
  @Input() isInteger = false;
  @Input() hideLabel = false;
  @Input() hideErrors = false;
  @ViewChild('error') error;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/shared/components/forms/input-field/input-field.component.ts